import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConnectionService } from './Connection/connection.service';
import { CacheService } from './Cache/cache.service';
import { Router } from '@angular/router';
import { UserService } from './User/user.service';

@Injectable({
  providedIn: 'root'
})
export class LogsService {


  urlLogs = environment.apiLogs;
  company_id!: string;
  user_id!: string;

  nameCompany = this.cacheService.getItemLocal('nameCompany');

  //Types = sucess | error | warn

  constructor(
    private httpClient: HttpClient, 
    private connection: ConnectionService, 
    private cacheService: CacheService, 
    private router: Router,
    private userService: UserService
    ) {
    this.connection.company$.subscribe((newCompany) =>{
      if(newCompany)
        this.company_id = newCompany.company.id_company;
    })

    this.connection.user$.subscribe((user) =>{
      if(user)
        this.user_id = user.id_customer;
    })
  }

  //Monta e envia os logs para o servidor
  sendLogs(message: string, type: string, context = {}){
    
    const body = {
      nameCompany: this.nameCompany,
      company_id: this.company_id,
      appVersion: environment.version,
      message: message,
      type: type,
      context: context, 
      userAgent: navigator.userAgent,
      language: navigator.language,
      online: navigator.onLine,
      platform: navigator.platform,
      url: window.location.href,
      route: this.router.url,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      sessionId: this.connection.getSessionId(),
      user_id: this.user_id || 'Not Logged'
    }

    this.sendRequest(body).subscribe(
    (data) => {
      console.log('log registrado com sucesso', data)
    },
    (error)=>{
      console.log(error)
    });
  }

  //POST - Envia logs para o servidor
  sendRequest(body: any): Observable<any>{

    const url = `${this.urlLogs}/logs/log-report-front`;

    return this.httpClient.post<any>(url, body)
  }
}
